import React, { useMemo } from "react";

import PropTypes from "prop-types";

import {

  PRODUCT_SHELL_LAYOUT,

  resolveProductShellLayout,

  isExtensionProductShell,

  isCartDrawerVerticalShell,

} from "../../../../shared/product-shell-layout.js";

import VerticalProductLayout from "./layouts/vertical-v1/VerticalProductLayout";

import HorizontalProductLayout from "./layouts/horizontal-v1/HorizontalProductLayout";

import ExtensionCompactLayout from "./layouts/extension-compact-v1/ExtensionCompactLayout";

import ExtensionTwoColumnLayout from "./layouts/extension-two-column-v1/ExtensionTwoColumnLayout";

import CartDrawerVerticalProductLayout from "./layouts/cart-drawer-vertical-v1/CartDrawerVerticalProductLayout";

import CartDrawerHorizontalProductLayout from "./layouts/cart-drawer-horizontal-v1/CartDrawerHorizontalProductLayout";



const STOREFRONT_LAYOUTS = Object.freeze({

  [PRODUCT_SHELL_LAYOUT.VERTICAL]: VerticalProductLayout,

  [PRODUCT_SHELL_LAYOUT.HORIZONTAL]: HorizontalProductLayout,

  [PRODUCT_SHELL_LAYOUT.CART_DRAWER_VERTICAL]: CartDrawerVerticalProductLayout,

  [PRODUCT_SHELL_LAYOUT.CART_DRAWER_HORIZONTAL]: CartDrawerHorizontalProductLayout,

  [PRODUCT_SHELL_LAYOUT.CART_DRAWER_CHECKBOX_STACK]: CartDrawerHorizontalProductLayout,

  [PRODUCT_SHELL_LAYOUT.CART_DRAWER_FBT_BUNDLE]: CartDrawerHorizontalProductLayout,

});



/**

 * Single entry point for all product card layouts.

 * Picks layout folder by `product.setting.layout.shell` (template-driven).

 */

export default function CatalogProductShell({

  section,

  productData,

  productIndex = 0,

  popupData,

  shellId: shellIdProp,

  extensionProps,

  ...rest

}) {

  const shellId = useMemo(

    () => shellIdProp || resolveProductShellLayout(section, popupData),

    [shellIdProp, section, popupData]

  );



  if (isExtensionProductShell(shellId)) {

    if (shellId === PRODUCT_SHELL_LAYOUT.EXTENSION_TWO_COLUMN) {

      return (

        <ExtensionTwoColumnLayout

          popupData={popupData}

          section={section}

          activeStep={rest.activeStep}

          parentIndex={extensionProps?.parentIndex ?? rest.parentIndex}

          footerContent={extensionProps?.footerContent}

        />

      );

    }

    return (

      <ExtensionCompactLayout

        popupData={popupData}

        section={section}

        activeStep={rest.activeStep}

        parentIndex={extensionProps?.parentIndex ?? rest.parentIndex}

        footerContent={extensionProps?.footerContent}

        extensionVariant={extensionProps?.extensionVariant}

      />

    );

  }



  const Layout =

    STOREFRONT_LAYOUTS[shellId] || STOREFRONT_LAYOUTS[PRODUCT_SHELL_LAYOUT.VERTICAL];



  return (

    <Layout

      section={section}

      productData={productData}

      productIndex={productIndex}

      popupData={popupData}

      shellId={shellId}

      {...rest}

    />

  );

}



CatalogProductShell.propTypes = {

  section: PropTypes.object,

  productData: PropTypes.object,

  productIndex: PropTypes.number,

  popupData: PropTypes.object,

  shellId: PropTypes.string,

  extensionProps: PropTypes.shape({

    parentIndex: PropTypes.number,

    footerContent: PropTypes.node,

    extensionVariant: PropTypes.string,

  }),

};


